import {TOptional} from 'shared/types/generics';
import {ILookupEntry} from 'shared/types/lookups';
import {
    TReportConfigurationDocumentFormat,
    IReportConfigurationExportToDto,
} from 'store/slices/report-configuration-slice/report-configuration-dto';

export const getExportDataValues = (
    formatOptions: ILookupEntry[] = [],
    programOptions: ILookupEntry[] = [],
) => formatOptions?.map(format => {
    const program = programOptions
        .find(option => option?.lookupCode === format.attribute1);

    return ({
        format: format.lookupCode as TReportConfigurationDocumentFormat,
        monitorProgramCode: program?.lookupCode,
        enabled: true,
    } as TOptional<IReportConfigurationExportToDto, 'monitorProgramCode' | 'monitorProgramId'>);
});

export const initialExportToData: TOptional<IReportConfigurationExportToDto,
    'monitorProgramCode' | 'monitorProgramId'>[] = [
        {
            format: 'PDF',
            monitorProgramCode: undefined,
            enabled: false,
        },
        {
            format: 'DOCX',
            monitorProgramCode: undefined,
            enabled: false,
        },
        {
            format: 'XLSX',
            monitorProgramCode: undefined,
            enabled: false,
        },
        {
            format: 'CSV',
            monitorProgramCode: undefined,
            enabled: false,
        },
    ];
